"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFeatureFlag = void 0;
const api_1 = require("core/api");
const React = __importStar(require("react"));
const react_router_1 = require("react-router");
const useNavigation_1 = require("./useNavigation");
const useRequest_1 = require("./useRequest");
const getEnableStripe = () => {
    try {
        return sessionStorage.getItem('enableStripe') === 'true';
    }
    catch (_e) {
        return false;
    }
};
const useFeatureFlag = (context) => {
    const { teamId } = (0, react_router_1.useParams)();
    const urlParams = new URLSearchParams(window.location.search);
    const enableStripe = urlParams?.get('enableStripe');
    const enableStripeSession = getEnableStripe();
    const { navigate } = (0, useNavigation_1.useNavigation)();
    const { makeRequest } = (0, useRequest_1.useRequest)();
    const checkRolloutInclusion = async () => {
        if (enableStripe === 'true' || enableStripeSession) {
            sessionStorage.setItem('enableStripe', 'true');
            return;
        }
        const { data } = await makeRequest(() => api_1.RolloutService.getOnboardingRolloutInclusion());
        if (data?.isEnabled === false && context === 'signup') {
            navigate.goToClassicSignup();
            return;
        }
        if (data?.isEnabled === false && context === 'teamPlan') {
            teamId && navigate.goToClassicTeamPlan(teamId);
            return;
        }
        if (data?.isEnabled === false && context === 'teamNew') {
            navigate.goToClassicNewTeam();
            return;
        }
    };
    React.useEffect(() => {
        checkRolloutInclusion();
    }, []);
    return null;
};
exports.useFeatureFlag = useFeatureFlag;
